import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';

import LecomLabel from '../../../form/components/label/label.jsx';

import { forwardPropsToState } from '../../../utils/react_utils';
import { FormEvents, FormEventHandler } from '../../../form/events/form_event_handler';
import { FormAPI } from 'lecom-api';
import { formatDateToBasic } from 'utils/date_utils_new.js';

const RealizeInputTextarea = window.InputTextarea;

@forwardPropsToState([{ prop: 'value', defaultValue: '' }])
@mixin.decorate(window.CssClassMixin)
@mixin.decorate(window.InputComponentMixin)
export default class InputTextarea extends React.Component {
	componentDidUpdate(prevProps, prevState) {
		const $node = $(`#input__${this.props.id}`);
		const $nodeInput = $(this.refs.input);
		const $nodeError = $node.find(".form__input-error");

		$nodeError.css({
			top: `${$nodeInput.height() + 30}px`
		});

		const canRecalculateActionButtonPosition = prevState.value !== this.state.value && this.props.actionButtonId;

		if (canRecalculateActionButtonPosition) {
			const textarea = ReactDOM.findDOMNode(this.refs.input);
			const actionButton = document.getElementById(this.props.actionButtonId);

			this.calculateActionButtonPosition(actionButton, textarea);
		}
	}

	/**
	 * Recalcula a posição dos botões de ações caso o textarea tenha scroll
	 * @param {HTMLElement} actionButton botão de ação
	 * @param {HTMLElement} textarea elemento input
	 */
	calculateActionButtonPosition(actionButton, textarea) {
		if (!actionButton || !textarea) {
			return;
		}

		const hasVerticalScroll = textarea.scrollHeight > textarea.clientHeight;

		const offsetRight = 14;
		let scrollbarWidth = 0;

		if (hasVerticalScroll) {
			scrollbarWidth = textarea.offsetWidth - textarea.clientWidth;
		}

		actionButton.style.right = `${offsetRight + scrollbarWidth}px`;
	}

	componentDidMount(){
		this.focusReadOnly();
	}
	collapseEnuns() {
		return this.props.historyCollapse ? {
			collapseText: Realize.i18n.t('history.show'),
			collapseIcon: 'keyboard_arrow_down'
		} : {
				collapseText: Realize.i18n.t('history.hide'),
				collapseIcon: 'keyboard_arrow_up'
			}
	}

	onKeyDownCollpaseHistory(e){
		if(e.keyCode === 13){
			this.onCollpaseHistory();
		}
	}

	renderHistory() {
		if (this.props.historyProps && this.props.historyProps.length) {
			return (
				<div id={`history__field-${this.props.id}`} className="history" ref={`historyField`}>
					<a className='collapse' onClick={this.onCollpaseHistory.bind(this)} onKeyDown={this.onKeyDownCollpaseHistory.bind(this)}
					tabIndex="0" aria-expandable={this.props.historyCollapse ? false : true} aria-label={this.collapseEnuns().collapseText}>
						<span className='collapse-text'>{this.collapseEnuns().collapseText}</span>
						<i className="material-icons" aria-hidden="true">{this.collapseEnuns().collapseIcon}</i>
					</a>
					<div className={`history__container${this.props.historyCollapse ? ' hide' : ''}`}>
						{this.props.historyProps.map(history => (
							<div className="history__item">
								<div className="history__item-header">
									<p tabIndex="0">{history.activityName} {Realize.i18n.t('history.by')} {history.responsible} {Realize.i18n.t('history.in')} {formatDateToBasic(history.executionDate)}</p>
								</div>
								<div className="history__description" tabIndex="0">{history.description}</div>
							</div>
						))}
					</div>
				</div>
			)
		}
		return null;
	}

	onCollpaseHistory() {
		const field = this.getFieldAPI();
		if (field) {
			field.historyCollapse(!this.props.historyCollapse).apply();
			setTimeout(function(){
				field.publish(FormEvents.CLICK);
			}, 100);
		}
	}

	getFieldAPI() {
		if (this.props.formId) {
			const formAPI = FormAPI.form(this.props.formId);
			return (this.props.gridFormParent)
				? formAPI.fields(this.props.gridFormParent).fields(this.props.id)
				: formAPI.fields(this.props.id);
		}
		return null;
	}

	handleFocus(event) {
		this.props.onFocus(event);
	}

	labelIsActive() {
		const inputValue = this.state.value;
		return (inputValue != null && String(inputValue).length > 0);
	}

	focusReadOnly(){
		let readOnly = this.props.readOnly;

		if(readOnly){
			let id = this.props.id;
			let textArea = $(`#${id}`);

			textArea.on('focus', () => {
				textArea.select();
			})
		}
	}

	renderTextArea(){
		return (
			<div className="text-area">
				<LecomLabel
					{...this.propsWithoutCSS()}
					id={this.props.id}
					active={this.labelIsActive()}
					key={`lecom--label__${this.props.id}`}
				/>
				<textarea
					{...this.props}
					value={this.state.value}
					placeholder={this.getPlaceholder()}
					className={this.inputClassName()}
					onChange={this._handleChange.bind(this)}
					onFocus={this.handleFocus.bind(this)}
					aria-label={Realize.i18n.t('general.textarea.maxlength').replace('@', this.state.value.length).replace('#', (this.props.maxLength > 60000 ? 60000 : this.props.maxLength))}
					aria-valuenow={this.state.value.length}
					aria-valuemax={this.props.maxLength > 60000 ? 60000 : this.props.maxLength}
					maxLength={this.props.maxLength > 60000 ? 60000 : this.props.maxLength}
					aria-labelledb={`${this.props.id}-${this.props.formId}`}
					aria-labelledby={`${this.props.id}-${this.props.formId}`}
					ref="input"
				/>
				{
					this.props.history ?
						this.renderHistory() :
						null
				}
			</div>
		);
	}

	render() {
		return this.renderTextArea();
	}

}

InputTextarea.defaultProps = {
	rows: 4,
	themeClassKey: 'input.textarea',
	historyCollapse: false
}

InputTextarea.propTypes = {
	rows: PropTypes.number
}
